module.exports = __webpack_public_path__ + "img/service-part3-cn.8bcdd564.png";